module.exports = __webpack_public_path__ + "img/banner.acd97ebf.png";